module.exports = __webpack_public_path__ + "static/img/ls26.66e2053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls26.png
// module id = Uo7Y
// module chunks = 12